/**
 * @param path - A path
 * @returns The path with the current projectId route parameter prepended
 */
export function getProjectPath(path?: string) {
  const route = useRoute()
  // Fall back to a less broken looking 'default' (vs undefined) and let the auth middleware deal with it
  // AFAICT this is only needed on the one edge case which is the TLAR link in the Advisor Portal menu
  const projectId = route.params.projectId || 'default'
  return `/project/${projectId}${!path || path === '/' ? '' : path}`
}
